import { get } from '../api/client';

interface PublicSiteIcon {
  faviconUrl?: string;
}

/**
 * 只在启动时取一次：管理端入口挂了 StrictMode，开发环境每个 effect 会跑两遍，
 * 模块级标记把重复请求挡掉；失败时把标记放回，留给下一次挂载重试。
 */
let requested = false;

/**
 * 把后台「站点信息 → Favicon」下发的图标挂到管理端标签页。
 *
 * 后台留空时不改 `index.html` 里写死的默认 `/favicon.ico`——清空这一项的意思是「用默认」，
 * 不是「把图标摘掉」。
 */
export function applySiteIcon(): void {
  if (requested) return;
  requested = true;
  get<PublicSiteIcon>('/public/config')
    .then((config) => {
      const href = toIconHref(config?.faviconUrl);
      if (!href) return;
      let link = document.querySelector<HTMLLinkElement>("link[rel='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      link.href = href;
    })
    .catch(() => {
      requested = false;
    });
}

/**
 * 相对地址直接交给浏览器按管理端自己的源解析：管理端站点的 nginx 也反代 `/uploads/`，
 * 同源就可达，所以不像 APP 那样需要拼 API origin。
 * 补前导斜杠是防有人手填 `uploads/x.png`——那种写法会被按当前路由解析成
 * `/orders/uploads/x.png`，在深链接上就取不到图。
 */
function toIconHref(value: unknown): string {
  const trimmed = typeof value === 'string' ? value.trim() : '';
  if (!trimmed) return '';
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
}
